module.exports = __webpack_public_path__ + "static/bg.989a1bc3.png";